var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
// Get single access point
const getAccessPoint = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${accessPointUid}`);
    return response;
});
const getAccessPointSettings = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${accessPointUid}/settings`);
    return response;
});
const putAccessPointSettings = (accessPointUid, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put(`AccessPoints/${accessPointUid}/settings`, data);
    return response;
});
const getAllAccessPoints = (query, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const params = {
        pageNumber: query.pageNumber,
        pageSize: query.pageSize,
        sortColumn: query.sortColumn,
        sortDirection: query.sortDirection,
    };
    if (query.filters) {
        if (query.filters.globalSearch) {
            params["Filters.GlobalSearch"] = query.filters.globalSearch;
        }
        if (query.filters.isActive !== undefined &&
            query.filters.isActive !== null) {
            params["Filters.IsActive"] = query.filters.isActive;
        }
        if (query.filters.accessPointName) {
            params["Filters.AccessPointName"] = query.filters.accessPointName;
        }
        if (query.filters.updatedAt) {
            params["Filters.UpdatedAt"] = query.filters.updatedAt;
        }
    }
    const response = yield siteX.get("AccessPoints", { params, signal });
    return response;
});
// Get access point general settings
const getAccessPointGeneral = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${accessPointUid}/general`);
    return response;
});
// Update access point general settings
const updateAccessPointGeneral = (accessPointUid, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put(`AccessPoints/${accessPointUid}/general`, Object.assign(Object.assign({}, data), { isGeneralSettings: true }));
    return response;
});
// Get access point configuration settings
const getAccessPointConfiguration = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${accessPointUid}/configuration`);
    return response;
});
// Update access point configuration settings
const updateAccessPointConfiguration = (accessPointUid, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put(`AccessPoints/${accessPointUid}/configuration`, Object.assign(Object.assign({}, data), { isGeneralSettings: false }));
    return response;
});
// Legacy update method
const updateAccessPoint = (accessPointUid, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put(`AccessPoints/${accessPointUid}`, data);
    return response;
});
const createAccessPointConfig = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("AccessPoints/config", data, {
        responseType: "blob",
    });
    return response;
});
// Get access points for dropdown
const getAccessPointsDropdown = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("AccessPoints/dropdown");
    return response;
});
const requestMaintenance = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("AccessPoints/request-maintenance", data);
    return response;
});
const getMaintenanceRequests = (apUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AccessPoints/${apUid}/maintenance-requests`);
    return response;
});
// Get access points statistics
const getStatistics = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("AccessPoints/statistics");
    return response;
});
// Soft delete access point (and remove from all users' AccessPoints)
const deleteAccessPoint = (accessPointUid) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.delete(`AccessPoints/${accessPointUid}`);
    return response;
});
export const accessPointsApi = {
    getAccessPoint,
    getAccessPointSettings,
    putAccessPointSettings,
    getAllAccessPoints,
    getAccessPointGeneral,
    updateAccessPointGeneral,
    getAccessPointConfiguration,
    updateAccessPointConfiguration,
    updateAccessPoint,
    createAccessPointConfig,
    getAccessPointsDropdown,
    requestMaintenance,
    getMaintenanceRequests,
    getStatistics,
    deleteAccessPoint,
};
